import type { Localized, SurveyInput } from "./types";

const L = (en: string, hi = ""): Localized => ({ en, hi });

/** A new draft with the default intro / thank-you / feedback copy. */
export function newSurveyInput(title: string): SurveyInput {
  return {
    title,
    content: {
      intro: {
        title: L("Help us make Fincurry better", "Fincurry को बेहतर बनाने में मदद करें"),
        body: L("A few quick questions. Your answers decide what we build next."),
      },
      thankYou: {
        title: L("Thank you!", "धन्यवाद!"),
        body: L("Your answers go straight to the team."),
      },
      feedback: {
        enabled: true,
        prompt: L("Anything else you'd like to tell us?", "और कुछ बताना चाहेंगे?"),
        maxChars: 300,
      },
    },
    questions: [],
    audience: {},
    startAt: null,
    endAt: null,
    responseLimit: null,
    maxShows: 3,
    showCooldownHours: 48,
    maxDismissals: 3,
    testEmails: [],
  };
}
